// extracted by mini-css-extract-plugin
export default {"noticeview":"bcaac7e5603ba94df9f1","icon":"efc6aa2226372b2e0263","text":"bcc1edfe324dfeb65695"};